import React, { useState, useRef, useLayoutEffect } from "react";
import classnames from "classnames";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import "./DateRange.scss";

import { DateRangePicker, DateRange as Dr } from "react-date-range";
import ru from "date-fns/locale/ru";

import moment from "moment";

import { defaultStaticRanges } from "./ranges";

import Button from "../Button/Button";

import { useOnClickOutside } from "./outside";
import SvgInline from "../SvgInline";
import CalendarIcon from "!svg-inline-loader!./calendar.svg";

function renderLabel(startDate, endDate) {
  const d1 = moment(startDate).format("DD-MM-YYYY");
  const d2 = moment(endDate).format("DD-MM-YYYY");

  return `${d1} - ${d2}`;
}

const DateRange = ({ startDate, endDate, onChange, theme, className }) => {
  const [range, setRange] = useState({ startDate, endDate });
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useOnClickOutside(ref, () => {
    setOpen(false);
  });

  const apply = () => {
    onChange(range);
    setOpen(false);
  };

  const handleChange = e => {
    const done = e.selection.key == "fast";

    const change = {
      startDate: e.selection.startDate,
      endDate: e.selection.endDate
    };

    setRange(change);

    if (done) {
      onChange(change);
      setOpen(false);
    }
  };

  const toggleOpen = () => {
    setOpen(prev => !prev);
  };

  const ranges = [
    {
      startDate: moment(range.startDate).toDate(),
      endDate: moment(range.endDate).toDate(),
      key: "selection"
    }
  ];

  return (
    <div
      className={classnames("eq-date", theme, className, { open: open })}
      ref={ref}
    >
      <div className="eq-date__control" onClick={toggleOpen}>
        <SvgInline src={CalendarIcon} className="eq-date__icon" />
        {renderLabel(startDate, endDate)}
      </div>
      {open && (
        <div className="eq-date__calendar">
          <DateRangePicker
            locale={ru}
            ranges={ranges}
            onChange={handleChange}
            staticRanges={defaultStaticRanges}
          />
          <Button onClick={apply}>Применить</Button>
        </div>
      )}
    </div>
  );
};

export default DateRange;
